import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { FuseConfirmationConfig } from "@nx-workspace/fuse";
import { ButtonWrapperComponent } from "../button-wrapper/button-wrapper.component";
import { MatIconModule } from "@angular/material/icon";
import { CommonModule } from "@angular/common";

@Component({
    selector: "v2-confirmation-dialog",
    templateUrl: "./dialog.component.html",
    styleUrls: ["./dialog.component.scss"],
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [ButtonWrapperComponent, MatIconModule, CommonModule, MatDialogModule],
})
export class V2ConfirmationDialogComponent implements OnInit {
    /**
     * Constructor
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: FuseConfirmationConfig,
        public matDialogRef: MatDialogRef<V2ConfirmationDialogComponent>
    ) {
        this.matDialogRef.addPanelClass("v2-confirmation-dialog-panel");
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
}
